import { InputBase } from "@mui/material";
import React, { useState } from "react";
import CompDirection from "../themes/CompDirection";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
// import SearchIcon from "@mui/icons-material/Search";

const SearchB = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "8px",
  backgroundColor: "#FFFFFF",
  border: "1px solid #0000001f",

  marginLeft: 0,
  height: "40px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(0),
  },
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#0000001F",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "#081735",

  height: "38px",

  font: "normal normal normal 14px/20px Lato",
  letterSpacing: "0px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),

    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),

    [theme.breakpoints.up("sm")]: {
      "&:focus": {},
    },
  },
}));

const PlainSearchCard = (props: any) => {
  const { t } = useTranslation();
  const trans: any = t;
  const [val, setVal] = useState("");
  const handleSeach = (e: any) => {
    setVal(e.target.value);
    props.onChange(e.target.value);
  };
  return (
    <CompDirection>
      <SearchB>
        <SearchIconWrapper>
          <i
            className="las la-search"
            style={{ height: "1em", width: "1em", color: "#8F95B2" }}
          />
        </SearchIconWrapper>
        <StyledInputBase
          onChange={handleSeach}
          value={val}
          placeholder={trans("Search here")}
          inputProps={{ "aria-label": "search" }}
          style={{
            width: props.width,
            alignContent: "center",
          }}
        />
      </SearchB>
    </CompDirection>
  );
};
export default PlainSearchCard;
